import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import * as endPoint from "../services/api";

export const syncSlice = createApi({
  reducerPath: "syncApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SYNC_URL, // ✔ only sync API domain
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("authToken");
      console.log("DEBUG: syncSlice prepareHeaders", { token: !!token });
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    syncApi: builder.mutation({
      query: (data) => ({
        url: endPoint.syncApiConnection({}), // /chat/user/sync
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useSyncApiMutation } = syncSlice;
